import React, {LegacyRef, MutableRefObject, useEffect, useRef, useState} from "react";
import {mayBe} from "./utils";
import {DocRow, DocTitle} from "../../components";
import {QRFooter} from "../qr_footer/QRFooter";
import {DocTable} from "../../components/doc_table/DocTable";
import {FlsoborvedResponse} from "../../types/flsobrved";
import {DocumentsBatch} from "../../types";
import {selectedDocument} from "./index";
import {AvailableDocuments} from "./AvailableDocuments";

export const FlsoborvedDoc: React.FC<{ documents: DocumentsBatch, withVersions?: boolean }> = ({
                                                                                                   documents,
                                                                                                   withVersions = true
                                                                                               }) => {

    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>(
            {
                document: documents.documents[0],
                documentTypeName: documents.documentsType
            });

    const [doc, setDocument] = useState<FlsoborvedResponse>(
            selectedDocument.document.document as FlsoborvedResponse
    )

    useEffect(() => {
        setDocument(selectedDocument.document.document as FlsoborvedResponse);
    }, [selectedDocument.document.version]);

    const title = `Оборотная ведомость по финансовому лицевому счёту о начислениях и оплатах за жилищно-коммунальные и иные услуги № б/н`;
    const subTitle = `Выдана заявителю:`;

    return (
            <>
                <div className="col-span-12 md:col-span-12">
                    <DocTitle title={title} subtitle={subTitle} uid={doc.blockchainUid}/>
                </div>

                <div className="col-span-12 md:col-span-8">
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Наниматель/Собственник" bold value={mayBe(doc.data.ownersFio) || '-'}/>
                        <DocRow title="Адрес" bold value={mayBe(doc.data.addrstr) || '-'}/>
                        <DocRow title="Финансовый лицевой счет" bold value={mayBe(doc.data.fnum) || '-'}/>
                        <DocRow title="Код плательщика" bold value={mayBe(doc.data.pcode) || '-'}/>
                    </div>

                    <DocTitle title={''} subtitle={'Период'}/>
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title={`Задолженность по оплате жилого помещения, коммунальных и иных услуг на ${doc.data.sdSaldoIn} г.`}
                                bold value={mayBe(doc.data.minSaldoIn) || '-'}/>
                        <DocRow title={`Задолженность по оплате жилого помещения, коммунальных и иных услуг на ${doc.data.fdSaldoOut} г.`}
                                bold value={mayBe(doc.data.maxSaldoOut) || '-'}/>
                    </div>
                </div>

                {
                        withVersions && documents.documents.length > 0 &&
                        <div className="col-span-12 md:col-end-13 md:col-span-3 order-first md:order-3">
                            <AvailableDocuments
                                    docs={documents}
                                    setSelectedDocument={setSelectedDocument}
                                    className={'-mt-12'}
                            />
                        </div>
                }


                <div className="col-span-12 md:col-span-12 md:order-last">
                    <DocTable
                            className={'doc-table--m2 doc-table--oborved-debt bottom-line'}
                            title={'Перечень задолженностей по услугам'}
                            headers={[
                                'Наименование услуги',
                                'Входящее сальдо',
                                'Тариф',
                                'Кол-во услуги',
                                'Начислено',
                                'Сумма льгот',
                                'Перерасчет',
                                'Итого начислено',
                                'Иные оплаты',
                                'Оплачено по Банку',
                                'Дата поступления оплаты',
                                'Итого оплачено',
                                'Разовые операции',
                                'Корректировка сальдо',
                                'Исходящее сальдо',
                            ]}
                            rows={
                                doc.serv.map(s => [
                                    mayBe(s.name) || '-',
                                    mayBe(s.saldoIn) || '-',
                                    mayBe(s.tarif) || '-',
                                    mayBe(s.quantity) || '-',
                                    mayBe(s.nach) || '-',
                                    mayBe(s.lg) || '-',
                                    mayBe(s.recalc) || '-',
                                    mayBe(s.nachItog) || '-',
                                    mayBe(s.opl) || '-',
                                    mayBe(s.oplBm) || '-',
                                    mayBe(s.oplDate) || '-',
                                    mayBe(s.oplItog) || '-',
                                    mayBe(s.raz) || '-',
                                    mayBe(s.corr) || '-',
                                    mayBe(s.saldoOut) || '-',
                                ])}
                            isBoldRow={(cells, index) => cells[0].toLowerCase().includes('итого')}
                            empty={'-'}/>


                    <QRFooter blockchainUid={doc.blockchainUid}
                              refDate={doc.data.curdate}
                              mfcInfoName={doc.data.firmName}
                              mfcUserName={doc.data.userName}
                    />
                </div>
            </>
    );
};
